import { EnvironmentMarker } from '@gonfalon/environments/EnvironmentMarker';
import { getEnvironmentQuery } from '@gonfalon/rest-api/queries/environments';
import { useQuery } from '@tanstack/react-query';

// Just the marker + name body. The wrapping span (with role/tabIndex/onClick
// + optional <Focusable> for tooltip support) is provided by the call site,
// because <Focusable> from react-aria-components requires its child to be a
// raw DOM element — wrapping a custom component prevents the TooltipTrigger's
// hover/focus listeners from binding.
export function EnvironmentBadgeContent({
  projectKey,
  environmentKey,
}: {
  projectKey: string;
  environmentKey: string;
}) {
  const { data: environment } = useQuery(getEnvironmentQuery({ projectKey, environmentKey }));
  return (
    <>
      <EnvironmentMarker color={environment?.color ?? ''} />
      <span>{environment?.name ?? environmentKey}</span>
    </>
  );
}
